export default __webpack_public_path__ + "static/media/pokemon_special_illustration_rare.56c8c7c0.svg";